import React from "react";
import classNames from "classnames/bind";

// assets
import { BellIcon, CalenderFill, LocationIcon } from "src/assets/icons";

import styles from "./MainSection.module.scss";
const cx = classNames.bind(styles);

const Item = ({ data }) => {
  return (
    <div className={cx("item-root")}>
      <div className={cx("content-section")}>
        <h3 className={cx("title")}>{data.EventName}</h3>
        <div className={cx("icon-wrapper")}>
          <LocationIcon />
          <span>{data.Location}</span>
        </div>
        <div className={cx("icon-wrapper")}>
          <CalenderFill />
          <span>{data.StartTime}</span>
        </div>
        <button className={cx("notify-btn")}>
          <BellIcon /> Notify me
        </button>
      </div>
      <div
        className={cx("img-section")}
        style={{ backgroundImage: `url(${data.Image})` }}
      >
        <span className={cx("category")}>{data.CategoryName}</span>
      </div>
    </div>
  );
};

export default Item;
